import { TableCell } from "@mui/material";
import { colors } from "assets/colors/colors";
import { BrandTableSelectableCell } from "./selectable_cell";

export const BrandTableBodyCell = ({
  column,
  row,
  formControl,
  formFieldName,
  tableProperties,
  index,
  rowHeight,
}) => {
  let child = row[column.dataKey];
  if (column.children) {
    child = column.children({
      rowData: row,
      tableProperties,
      isWideScreen: true,
      index: index,
    });
  } else if (
    column.selectable &&
    (typeof column.selectable === "function" ? column.selectable(row) : true) &&
    formControl &&
    formFieldName
  ) {
    child = (
      <BrandTableSelectableCell
        rowData={row}
        column={column}
        key={column.dataKey}
        formControl={formControl}
        formFieldName={formFieldName}
      />
    );
  }
  return (
    <TableCell
      key={column.dataKey}
      align={column.align || "left"}
      sx={{
        color: colors.core100,
        fontSize: "16px",
        ...(rowHeight
          ? {
              height: `${rowHeight}px`,
              py: 0,
              verticalAlign: "middle",
            }
          : undefined),
        ...(column.cellSx || {}),
      }}
    >
      {child}
    </TableCell>
  );
};
